import { useCampaignLiveModalStore } from '@forwardflow/store/modal/campaignLiveModal'
import { Button } from '@forwardflow/ui'
import { Modal } from 'antd'
import { useNavigate } from 'react-router-dom'

export const CampaignLiveModal = () => {
   const { isCampaignLiveModalOpen, closeCampaignLiveModal } =
      useCampaignLiveModalStore()
   const navigate = useNavigate()

   const handleGoToDashboard = () => {
      navigate('/campaign')
      closeCampaignLiveModal()
   }

   return (
      <Modal
         open={isCampaignLiveModalOpen}
         onCancel={closeCampaignLiveModal}
         footer={null}
         centered
         closable={false}
         className="p-0 ff-modal"
      >
         <div className="flex flex-col items-center px-6 py-8">
            <h2 className="mb-4 text-2xl font-medium text-center text-white">
               Your campaign is live!
            </h2>
            <p className="text-[#bdbdbd] text-center mb-5">
               Forward Flow is now working to reach your leads.You can always
               come back to edit or optimize your campaign anytime.
            </p>
            <Button
               className="w-full !border-none !h-12 font-semibold !mb-1 !rounded"
               onClick={handleGoToDashboard}
            >
               Go to Campaign Dashboard
            </Button>
            <Button
               className="w-full !bg-[#232326] !border-white/10 !rounded !h-12 font-semibold text-white hover:!text-white hover:!bg-white/10"
               onClick={closeCampaignLiveModal}
            >
               Keep Editing
            </Button>
         </div>
      </Modal>
   )
}
